import * as Sentry from '@sentry/vue';
import vueApp from '@/main';

const sanitizeHeaders = (headers = {}) => Object.keys(headers).reduce((acc, key) => {
  if (key.toLowerCase() === 'authorization') {
    acc[key] = '[Filtered]';
  } else {
    acc[key] = headers[key];
  }
  return acc;
}, {});

const captureErrorForSentry = (error, messages) => {
  const response = error && error.response ? error.response : error;
  const requestConfig = error && error.config ? error.config : {};
  const responseData = response && response.data ? response.data : {};
  const statusCode = responseData.code || response.status || 'unknown';
  const sentryMessage = responseData.message
    || error.message
    || `API request failed with status ${statusCode}`;

  Sentry.withScope((scope) => {
    scope.setLevel(statusCode >= 500 ? 'error' : 'warning');
    scope.setTag('resolver', 'getErrors');
    scope.setTag('http.status_code', String(statusCode));

    if (requestConfig.method) {
      scope.setTag('http.method', requestConfig.method.toUpperCase());
    }

    if (requestConfig.url) {
      scope.setTag('api.url', requestConfig.url);
    }

    scope.setContext('api_error', {
      responseCode: responseData.code || null,
      responseMessage: responseData.message || null,
      responseStatus: responseData.status,
      responseResult: responseData.result || null,
      responseMessageDetail: responseData.message_detail || null,
      userMessages: messages,
      requestUrl: requestConfig.url || null,
      requestMethod: requestConfig.method || null,
      requestBaseURL: requestConfig.baseURL || null,
      requestParams: requestConfig.params || null,
      requestData: requestConfig.data || null,
      requestHeaders: sanitizeHeaders(requestConfig.headers),
    });

    if (error instanceof Error) {
      Sentry.captureException(error);
      return;
    }

    Sentry.captureMessage(sentryMessage);
  });
};

export const getErrors = (error) => {
  const errors = error && error.response ? error.response : error;
  let messages = [];
  if (errors && errors.data && ([400, 404, 423].some((code) => code === errors.data.code))) {
    if (errors.data.result) {
      messages = Object.keys(errors.data.result).map((el) => errors.data.result[el]);
      messages = messages.map((item) => item.join());
    } else {
      messages.push(errors.data.message);
    }
  } else if (errors && errors.data && ([409, 403].some((code) => code === errors.data.code))) {
    if (errors.data.message_detail) {
      messages.push(errors.data.message_detail[0]);
    } else {
      messages.push(errors.data.message);
    }
  } else if (errors && errors.data && errors.data.code === 401) {
    messages.push(errors.data.message);
  } else {
    // to control unknown errors.
    messages.push('The given data was invalid.');
  }

  captureErrorForSentry(error, messages);
  return messages;
};

export const controlConnectionProblems = (error) => {
  if (error.response && error.response.data && !error.response.data.status) {
    if (error.response.data.code === 500) {
      vueApp.$root.errorMessage('Connection problem. Please try again later.');
    }
  } else if (!error.response) {
    vueApp.$root.errorMessage('Something went wrong. Please try again later.');
  }
};
